export default __webpack_public_path__ + "static/media/trampapo_02_14.7eaabcab.jpg";